import { AxiosResponse, AxiosError } from 'axios';

/**
 * Returns a new promise which resolves the axios response body or rejects with
 * the error data.
 */
export async function destructureAxiosReq<Response = any>(
  axiosPromise: Promise<AxiosResponse<Response>>
) {
  try {
    const { data } = await axiosPromise;
    return data;
  } catch (e) {
    const error = e as AxiosError;
    throw error.response ? error.response.data.error : error;
  }
}
